/*
* Story Theme
*
* Use this file to add custom Javascript to Story.  Keeping your custom
* Javascript in this fill will make it easier to update Story. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {
  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  // QuickAdd custom js BK LAD-3 11/15/22 and LAD-26 2/9/23
  let quickViewToggle = $('.custom-add-size-modal-wrap');
    quickViewToggle.show();
  let quickViewSizes = $('.size-list');
    quickViewSizes.hide();
  let quickViewClose = $('.size-list-close');
    quickViewClose.css('visibility', 'hidden');

 // Shows sizes on quick add click 
  quickViewToggle.click((e) => {
    console.log("clicked2");
    let target = e.target
    $('.size-list').hide();
    $('.size-list-close').css('visibility', 'hidden');
    $('.size-selector-text-wrapper').show();
    let closestToggle = target.closest(".custom-quick-add");
    let quickViewToggleText = $(closestToggle).find(".size-selector-text-wrapper")
    let closestQuickViewSizes = $(closestToggle).find(".size-list");
    let closestQuickViewClose = $(closestToggle).find(".size-list-close");
    quickViewToggleText.hide();
    closestQuickViewClose.css('visibility', 'visible');
    closestQuickViewSizes.show();
  });

  // Hide sizes on quick view close click
  quickViewClose.click((e) => {
    e.preventDefault();
    e.stopPropagation();
    $('.size-list').hide();
    $('.size-list-close').css('visibility', 'hidden');
    $('.size-selector-text-wrapper').show();
    console.log("end of click fn");
  });

  // Add to cart Quick add js.
  $("li.custom-size-btn").click((e) => {
    let target = event.target
    let id = $(target).attr("data-var-id");
    
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      type: 'POST',
      data: {
        quantity: 1,
        id: id
      },
      success: addToCartOk,
      error: addToCartFail
      })
  
      function addToCartOk(data) { 
          setTimeout(function() {
              window.fetch('/cart.js') 
              .then(function(response) {
              if(response.ok){
                return response.json().then(function(json) {
                  document.dispatchEvent(new CustomEvent('theme:cart:change', {
                  detail: {
                      cart: json,
                  },
                  bubbles: true,
                  }));  
                  document.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
                  const drawer = document.querySelector('[data-drawer="drawer-cart"]');
                  drawer.dispatchEvent(new CustomEvent('theme:drawer:open', {
                  detail: {
                      reinit: true
                  },
                  bubbles: true
                }));
              });
            } else {
              throw e;
            }    
          }).catch(e => { console.error(e)});             
        }, 1000); 
      } 
    function addToCartFail(obj, status) { 
    console.log('error', obj, status)
    }        
  })

  $(document).click((e) => {
    if(!(($(e.target).closest(".custom-add-size-modal-wrap").length > 0))) {
      $(".size-list").hide()
      $(".size-selector-text-wrapper").show();
      $('.size-list-close').css('visibility', 'hidden');
    }
  })
  // End LAD-3 and LAD-26
  

   /* var $cbs = $('input[name="option-0"].available').click(function() {
                var showSubmit = $(this).parents('.layer');
                showSubmit.find('button').toggle( $cbs.is(":checked") );
              });
  */
     $(document).on('change', '.pdp-grid-item .swatch :radio', function() {

                let currentProductId = $(this).data('current-product');
                //var optionIndex = $(this).closest('.swatch').attr('data-option-index');
                var optionValue = $(this).data('variant-id');
                $(this)
                .closest('form')
                .find('.select-variant')
                .val(optionValue)
                .trigger('change');
                console.log(optionValue);
                console.log($(`#product-${currentProductId}-variant`));
                $(`#product-${currentProductId}-variant`).val(optionValue);
                
                var showSubmit = $(this).parents('.layer');
        /*        showSubmit.find('button').toggle( $cbs.is(":checked") );*/
              });

  
  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
